import { put, takeLatest } from "redux-saga/effects";
import { getListNotificationApi } from "store/api/NotificationApi";
import { GET_LIST_NOTIFICATION_ACTION } from "../../actions/NotificationPageAction/actionTypes";

import * as notificationPageAction from "../../actions/NotificationPageAction";
import * as globalAction from "../../actions/GlobalAction";

function* errorMessage(message) {
	const alert = { isError: true, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* getListNotification(action) {
	yield put(globalAction.openLoadingPage());
	const res = yield getListNotificationApi(action.params);
	try {
		if (res?.code === 0) {
			yield put(
				notificationPageAction.setListNotificationAction(
					res?.data?.notifications
				)
			);
		} else {
			yield errorMessage(res?.message);
		}
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* getListNotificationSaga() {
	yield takeLatest(GET_LIST_NOTIFICATION_ACTION, getListNotification);
}

export default getListNotificationSaga;
